<template>
  <div class="apply-page">
    <van-cell-group>
      <van-cell :is-link='isLoan' :to="IsApplied?'./apply-detail-locate':'./apply-locate'" v-if='isLoan'>
        <div class='title-box' slot="title">
          <span class="custom-text">正畸定位器工具包</span>
        </div>
      </van-cell>
      <!-- <van-cell :is-link='isMuscle' :to="IsAppMuscle?'./apply-detail-muscle':'./apply-muscle'" v-show='isMuscle'>
        <div class='title-box' slot="title">
          <span class="custom-text">肌功能评估工具包</span>
        </div>
      </van-cell> -->
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data () {
    return {
      IsApplied: false,
      IsAppMuscle: false,
      isLoan: false,
      isMuscle: false,
    }
  },
  methods: {
    getCheckLoanOrthodonticLocate () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetCheckLoanOrthodonticLocate'
      }).then(res => {
        this.IsApplied = res.IsApplied
        this.IsAppMuscle = res.IsAppMuscle
        this.isLoan = res.IsLoan
        this.isMuscle = res.IsMuscle
      })
    },
  },
  mounted () {
    this.getCheckLoanOrthodonticLocate()
  }
}
</script>
<style lang="less" scoped>
.apply-info-page {
  padding: 30px 30px 50px 30px;
  p {
    margin-top: 20px;
    font-size: 30px;
    line-height: 45px;
    text-indent: 32px;
    color: @hGray;
  }
  .btns {
    width: 80%;
    margin: 40px auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/apply.vue